import { Appointment, APPOINTMENT_STATUS } from "@elixir/types";
import {
  cancelAppointmentReminders,
  getMe,
  sendAppointmentCommunication,
  updateAppointment,
} from "../../utils/bridges/methods";
import { ControllerReturnType } from "../types";
import { logAndGetErrorResponse } from "../error";
import { MESSAGE_TYPE } from "../../utils/bridges/events/types";
import {
  trackAppointmentActivity,
  AptActivityType,
} from "./appointment-activity";

export default async function cancelAppointment({
  appointment,
}: {
  appointment: Pick<Appointment, "aid" | "doctor_oid">;
}): Promise<ControllerReturnType> {
  try {
    const { aid, doctor_oid } = appointment;
    const { user } = getMe();

    let newStatus: APPOINTMENT_STATUS | null = null;
    if (user.oid === doctor_oid) {
      newStatus = APPOINTMENT_STATUS.DOCTOR_CANCELLED;
    } else {
      newStatus = APPOINTMENT_STATUS.STAFF_CANCELLED;
    }

    await updateAppointment({ data: { status: newStatus }, aid });
    //TODO - cancel Reminder of apt
    sendAppointmentCommunication({
      aid,
      data: { msg_type: MESSAGE_TYPE.CANCEL_APPOINTMENT },
    });
    cancelAppointmentReminders({ aid });
    trackAppointmentActivity({
      aid,
      activity: AptActivityType.VISIT_CANCELLED,
    });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
